/**
 * Объявление глобальных объектов.
 */

/**
 * @type {Boolean} Содержит true если сборка приложения выполнена для окружения разработчика.
 */
const isDevelopmentEnv = process.env.NODE_ENV === "development";

/**
 * Вернет true если включен режим для отладки.
 * Режим для отладки определяется на основе рабочего окружения, либо установки специальной куки, позволяющей на любом окружении
 * показать пользователю отладочную информацию.
 *
 * Пример включения режима отладки на рабочем окружении через установку специальной куки.
 * Можно сделать ссылку в закладках со следующим кодом вместо URL:
 *
 *  > javascript:(function(){document.cookie="capricorn=1";})();
 *
 * Для выключение режима:
 *
 *  > javascript:(function(){document.cookie="capricorn=0";})();
 *
 * @return {Boolean}
 */
window.isDebugMode = () => {
  return isDevelopmentEnv
    || document.cookie.split("; ").reduce((c, s) => {
      c[s.split("=")[0]] = s.split("=")[1];
      return c;
    }, {})["capricorn"] === "1";
};

/**
 * Специальный console.log для работы в режиме отладки.
 */
window.devLog = (...args) => {
  if (isDebugMode()) {
    console.log(...args);
  }
};
